import { createContext, useContext, useState, useEffect } from "react";

const dict = {
  pl: {
    nav: { offer: "Oferta", why: "Dlaczego my", process: "Jak to działa", faq: "FAQ", contact: "Kontakt" },
    hero: {
      tag: "Wakacje i wyjazdy fakultatywne",
      title1: "Madera",
      title2: "odkryta inaczej",
      desc: "Pakiety hotelowe, wycieczki z polskojęzycznym przewodnikiem, obozy sportowe i wyjazdy firmowe. Zorganizujemy Twój wymarzony pobyt na Perle Atlantyku – z transferem z lotniska.",
      cta: "Otrzymaj indywidualną ofertę",
      cta2: "Zobacz ofertę",
      reviews: "ponad 200 zadowolonych podróżników",
    },
    phone: "+48 721 707 010",
    usp: ["Transfer z lotniska", "Licencja RNAVT 11932", "Polskojęzyczna obsługa"],
    quiz: {
      step: "Krok",
      of: "z",
      perk: "Transfer z lotniska!",
      q1Title: "Jaki wyjazd Cię interesuje?",
      q1Sub: "Wybierz najbliższą opcję – pomożemy doprecyzować.",
      q2Title: "Kiedy planujesz wyjazd?",
      q2Sub: "Zaproponujemy najlepsze terminy i ceny.",
      q3Title: "Jaki budżet rozważasz?",
      q3Sub: "Mamy oferty w każdym przedziale cenowym.",
      q4Title: "Już prawie gotowe!",
      q4Sub: "Zostaw kontakt – odezwiemy się w ciągu 48h z gotową propozycją.",
      name: "Imię i nazwisko",
      email: "E-mail",
      phone: "Telefon",
      consent: "Wyrażam zgodę na kontakt w sprawie oferty i akceptuję politykę prywatności.",
      back: "Wstecz",
      next: "Dalej",
      submit: "Wyślij zapytanie",
      sending: "Wysyłanie...",
      successTitle: "Dziękujemy!",
      successDesc: "Twoje zapytanie zostało wysłane. Polski opiekun klienta z Madery skontaktuje się z Tobą w ciągu 48 godzin i przygotuje indywidualną ofertę.",
      footer: "Twoje dane są bezpieczne. Bez spamu. Licencje RNAVT n° 11932 / RNAAT n° 229/2026.",
      errSelectTrip: "Wybierz typ wyjazdu",
      errSelectTime: "Wybierz planowany termin",
      errSelectBudget: "Wybierz budżet",
      errName: "Podaj imię i nazwisko",
      errEmail: "Podaj e-mail",
      errConsent: "Wymagana zgoda na kontakt",
      sent: "Wysłano! Odezwiemy się w 48h.",
      failed: "Błąd wysyłki. Spróbuj ponownie.",
      tripOptions: ["Pakiet hotelowy / wczasy", "Wycieczki z przewodnikiem", "Obóz sportowy / zgrupowanie", "Wyjazd grupowy / firmowy", "Wynajem samochodu"],
      timelineOptions: ["Jak najszybciej", "W ciągu miesiąca", "W ciągu 3 miesięcy", "Później / planuję sezonowo", "Tylko się rozglądam"],
      budgetOptions: ["Do 1 500 € / osoba", "1 500 – 3 000 € / osoba", "3 000 – 5 000 € / osoba", "Powyżej 5 000 € / osoba"],
    },
    offer: {
      tag: "Nasza oferta",
      title1: "Wszystko, czego potrzebujesz",
      title2: "na rajskiej wyspie",
      desc: "Kompleksowa organizacja pobytów – od logistyki, przez zakwaterowanie, po atrakcje i transfery. Każda oferta przygotowywana indywidualnie.",
      cta: "Zapytaj o ofertę",
      items: [
        { title: "Pakiety hotelowe & wczasy", desc: "Od komfortowych 3* po luksusowe 5* z widokiem na Atlantyk. Bezpośrednie kontrakty z lokalnymi hotelami = lepsze ceny.", price: "od 498 €" },
        { title: "Wycieczki z przewodnikiem", desc: "Lewady, klif Cabo Girão, Pico do Areeiro, Santana. Indywidualne i grupowe trasy z polskojęzycznym przewodnikiem.", price: "od 50 €" },
        { title: "Obozy i zgrupowania sportowe", desc: "Piłka nożna, tenis, padel, lekkoatletyka, pływanie. Profesjonalne obiekty i kadra trenerska na całej wyspie.", price: "indywidualna wycena" },
        { title: "Wyjazdy firmowe & integracje", desc: "Incentive travel, team building, eventy korporacyjne łączące przygodę z relaksem na rajskiej wyspie.", price: "na zapytanie" },
        { title: "Wynajem samochodów", desc: "Auta osobowe, SUV-y, 7-osobowe vany. Odbiór z lotniska Funchal lub hotelu. Pełne ubezpieczenie i wsparcie 24/7.", price: "od 45 € / dzień" },
      ],
    },
    why: {
      tag: "Nasze atuty",
      title1: "Dlaczego",
      title2: "Madeira.com.pl?",
      desc: "Wieloletnie doświadczenie, licencjonowana działalność i osobiste podejście – to fundamenty naszej pracy.",
      items: [
        { title: "Licencja RNAVT 11932", desc: "Działamy legalnie z portugalską licencją turystyczną – pełna gwarancja bezpieczeństwa rezerwacji." },
        { title: "10+ lat doświadczenia", desc: "Setki zorganizowanych wyjazdów, klubów sportowych i grup. Znamy Maderę jak własną kieszeń." },
        { title: "Polskojęzyczna obsługa", desc: "Opiekun klienta po polsku na każdym etapie – od planowania, przez przewodnika, po wsparcie 24/7 na wyspie." },
      ],
    },
    process: {
      tag: "Jak to działa", title1: "Trzy kroki do", title2: "wymarzonego wyjazdu",
      cta: "Otrzymaj darmową wycenę",
      steps: [
        { title: "Wypełnij formularz", desc: "Krótki quiz w 4 krokach – mniej niż 2 minuty. Wybierz typ wyjazdu, termin i budżet." },
        { title: "Indywidualna oferta", desc: "W ciągu 48h przygotujemy dopasowaną propozycję – hotele, wycieczki, transfery, atrakcje." },
        { title: "Lecisz na Maderę", desc: "Odbieramy z lotniska (gratis!), dbamy o każdy szczegół. Ty po prostu cieszysz się wyspą." },
      ],
    },
    stats: [
      { suffix: "+", label: "lat doświadczenia" },
      { suffix: "+", label: "zorganizowanych wyjazdów" },
      { suffix: "%", label: "indywidualne oferty" },
      { suffix: "h", label: "czas odpowiedzi" },
    ],
    faq: {
      tag: "Najczęstsze pytania", title1: "FAQ – pytają nas", title2: "o to",
      items: [
        { q: "Co obejmuje darmowy transfer z lotniska?", a: "Przy każdym wyjeździe zarezerwowanym przez nas (od 7 dni) zapewniamy bezpłatny prywatny transfer z lotniska Funchal do hotelu i z powrotem." },
        { q: "Jak długo trwa przygotowanie oferty?", a: "Indywidualną propozycję otrzymasz w ciągu 48 godzin od wysłania formularza. Oferty grupowe i firmowe – do 72 godzin." },
        { q: "Czy organizujecie wyjazdy dla klubów sportowych?", a: "Tak. Specjalizujemy się w zgrupowaniach piłkarskich, tenisowych, lekkoatletycznych, pływackich i padlowych. Mamy bezpośrednie kontrakty z obiektami sportowymi." },
        { q: "W jakim języku odbywają się wycieczki?", a: "Wszystkie nasze wycieczki prowadzimy z polskojęzycznym przewodnikiem mieszkającym na Maderze." },
        { q: "Czy można płacić w ratach?", a: "Tak, oferujemy elastyczne formy płatności – zaliczka + raty przed wylotem. Szczegóły omawiamy indywidualnie." },
      ],
    },
    contact: {
      tag: "Kontakt", title1: "Porozmawiajmy o Twoim", title2: "wyjeździe na Maderę",
      desc: "Masz pytania lub chcesz umówić rozmowę? Zadzwoń lub napisz – polski opiekun klienta z Madery jest do Twojej dyspozycji.",
      call: "Zadzwoń", write: "Napisz", office: "Biuro",
      address: "Rua da Bolivia 72-JS, 9000-087 Funchal, Madeira",
      license: "Licencje turystyczne RNAVT n° 11932 / RNAAT n° 229/2026",
      formTitle: "Wyślij wiadomość",
      message: "Wiadomość",
      messagePlaceholder: "Opisz, jaki wyjazd Cię interesuje...",
      submit: "Wyślij wiadomość",
      sending: "Wysyłanie...",
      consent: "Akceptuję politykę prywatności i wyrażam zgodę na kontakt.",
      successTitle: "Dziękujemy!",
      successDesc: "Odezwiemy się tak szybko, jak to możliwe.",
      sent: "Wiadomość wysłana!",
      failed: "Błąd wysyłki. Spróbuj ponownie.",
      errRequired: "Wypełnij wymagane pola",
      errConsent: "Wymagana zgoda",
    },
    footer: { tag1: "Kontakt", tag2: "Nawigacja", tag3: "Śledź nas", desc: "Twój ekspert od podróży, wycieczek i obozów na Maderze.", rights: "Wszystkie prawa zastrzeżone." },
    cookies: {
      title: "Szanujemy Twoją prywatność",
      desc: "Używamy plików cookies do działania strony, analityki i remarketingu. Możesz zaakceptować wszystkie, odrzucić lub dostosować swoje preferencje.",
      accept: "Akceptuję wszystkie",
      reject: "Odrzuć",
      settings: "Ustawienia",
      save: "Zapisz wybór",
      essentialTitle: "Niezbędne",
      essentialDesc: "Konieczne do działania strony – formularz, sesja, bezpieczeństwo. Zawsze aktywne.",
      analyticsTitle: "Analityczne",
      analyticsDesc: "Pomagają nam mierzyć ruch i ulepszać stronę (Google Analytics).",
      marketingTitle: "Marketingowe",
      marketingDesc: "Pozwalają mierzyć skuteczność reklam i wyświetlać dopasowane oferty (Google Ads, Meta).",
    },
  },
  en: {
    nav: { offer: "Offer", why: "Why us", process: "How it works", faq: "FAQ", contact: "Contact" },
    hero: {
      tag: "Holidays & guided trips",
      title1: "Madeira",
      title2: "rediscovered",
      desc: "Hotel packages, English-speaking guided tours, sports camps and corporate trips. We organise your dream stay on the Pearl of the Atlantic – with an airport transfer.",
      cta: "Get a tailored quote",
      cta2: "See offer",
      reviews: "200+ happy travellers",
    },
    phone: "+351 913 254 957",
    usp: ["Airport transfer", "RNAVT 11932 license", "Bilingual support"],
    quiz: {
      step: "Step", of: "of", perk: "Airport transfer!",
      q1Title: "What kind of trip are you after?",
      q1Sub: "Pick the closest option – we'll refine it together.",
      q2Title: "When are you planning to go?",
      q2Sub: "We'll suggest the best dates and prices.",
      q3Title: "What budget are you considering?",
      q3Sub: "We have options at every price point.",
      q4Title: "Almost done!",
      q4Sub: "Leave your contact – we'll reach out within 48h with a ready proposal.",
      name: "Full name", email: "Email", phone: "Phone",
      consent: "I agree to be contacted about this offer and accept the privacy policy.",
      back: "Back", next: "Next", submit: "Send request", sending: "Sending...",
      successTitle: "Thank you!",
      successDesc: "Your request has been sent. Our Madeira-based client manager will reach out within 48 hours with a tailored offer.",
      footer: "Your data is safe. No spam. RNAVT n° 11932.",
      errSelectTrip: "Pick a trip type", errSelectTime: "Pick a timeline", errSelectBudget: "Pick a budget",
      errName: "Enter your name", errEmail: "Enter your email", errConsent: "Consent is required",
      sent: "Sent! We'll reply within 48h.", failed: "Send failed. Please try again.",
      tripOptions: ["Hotel package / holiday", "Guided tours", "Sports camp / training", "Group / corporate trip", "Car rental"],
      timelineOptions: ["As soon as possible", "Within a month", "Within 3 months", "Later / seasonal", "Just browsing"],
      budgetOptions: ["Up to €1,500 / person", "€1,500 – €3,000 / person", "€3,000 – €5,000 / person", "Over €5,000 / person"],
    },
    offer: {
      tag: "Our offer", title1: "Everything you need", title2: "on this paradise island",
      desc: "End-to-end trip planning – logistics, accommodation, attractions and transfers. Every offer is tailored to you.",
      cta: "Ask about this offer",
      items: [
        { title: "Hotel packages & holidays", desc: "From comfy 3-star to luxury 5-star with Atlantic views. Direct contracts with local hotels = better prices.", price: "from €498" },
        { title: "Guided tours", desc: "Levadas, Cabo Girão cliff, Pico do Areeiro, Santana. Private and group routes with a local English-speaking guide.", price: "from €50" },
        { title: "Sports camps & training", desc: "Football, tennis, table tennis, padel, athletics, swimming. Professional venues and coaches across the island.", price: "custom quote" },
        { title: "Corporate trips & retreats", desc: "Incentive travel, team building and corporate events blending adventure with relaxation on a paradise island.", price: "on request" },
        { title: "Car rental", desc: "Sedans, SUVs, 7-seater vans. Pick-up at Funchal airport or at your hotel. Full insurance and 24/7 support.", price: "from €45 / day" },
      ],
    },
    why: {
      tag: "Our strengths", title1: "Why", title2: "Madeira.com.pl?",
      desc: "Years of experience, licensed operation and a personal approach – these are the foundations of our work.",
      items: [
        { title: "RNAVT 11932 / RNAAT 229/2026 license", desc: "We operate legally with Portuguese tourism licenses (RNAVT 11932 and RNAAT 229/2026) – full booking security guaranteed." },
        { title: "Many years of experience", desc: "Hundreds of trips, sports clubs and groups organised. We know Madeira inside out." },
        { title: "Bilingual support", desc: "A dedicated client manager at every step – from planning to a guide on the ground, plus 24/7 in-island support." },
      ],
    },
    process: {
      tag: "How it works", title1: "Three steps to your", title2: "dream trip",
      cta: "Get a free quote",
      steps: [
        { title: "Fill the form", desc: "Quick 4-step quiz – under 2 minutes. Pick trip type, dates and budget." },
        { title: "Tailored offer", desc: "Within 48h we'll prepare a custom proposal – hotels, tours, transfers, attractions." },
        { title: "Fly to Madeira", desc: "We pick you up at the airport (free!), handle every detail. You just enjoy the island." },
      ],
    },
    stats: [
      { suffix: "+", label: "years of experience" },
      { suffix: "+", label: "trips organised" },
      { suffix: "%", label: "tailored offers" },
      { suffix: "h", label: "response time" },
    ],
    faq: {
      tag: "Frequently asked", title1: "FAQ – common", title2: "questions",
      items: [
        { q: "What does the free airport transfer include?", a: "For every trip booked with us (from 7 days) we provide a free private transfer from Funchal airport to your hotel and back." },
        { q: "How long does it take to prepare an offer?", a: "You'll get a tailored proposal within 48 hours of submitting the form. Group and corporate offers – up to 72 hours." },
        { q: "Do you organise trips for sports clubs?", a: "Yes. We specialise in football, tennis, athletics, swimming and padel camps. We have direct contracts with sports venues." },
        { q: "In what language are the tours conducted?", a: "We run all our tours with a guide based in Madeira – Polish and English available." },
        { q: "Can I pay in instalments?", a: "Yes, we offer flexible payment – deposit + instalments before departure. Details discussed individually." },
      ],
    },
    contact: {
      tag: "Contact", title1: "Let's talk about your", title2: "Madeira trip",
      desc: "Got questions or want to schedule a call? Phone or write – our Madeira-based client manager is here for you.",
      call: "Call", write: "Email", office: "Office",
      address: "Rua da Bolivia 72-JS, 9000-087 Funchal, Madeira",
      license: "Tourism licenses RNAVT n° 11932 / RNAAT n° 229/2026",
      formTitle: "Send a message", message: "Message", messagePlaceholder: "Tell us what trip you have in mind...",
      submit: "Send message", sending: "Sending...",
      consent: "I accept the privacy policy and agree to be contacted.",
      successTitle: "Thank you!", successDesc: "We'll get back to you as soon as possible.",
      sent: "Message sent!", failed: "Send failed. Please try again.",
      errRequired: "Fill in the required fields", errConsent: "Consent is required",
    },
    footer: { tag1: "Contact", tag2: "Navigation", tag3: "Follow us", desc: "Your expert in travel, tours and camps on Madeira.", rights: "All rights reserved." },
    cookies: {
      title: "We respect your privacy",
      desc: "We use cookies for site functionality, analytics and remarketing. You can accept all, reject, or customise your preferences.",
      accept: "Accept all",
      reject: "Reject",
      settings: "Settings",
      save: "Save selection",
      essentialTitle: "Essential",
      essentialDesc: "Required for the site to work – form, session, security. Always active.",
      analyticsTitle: "Analytics",
      analyticsDesc: "Help us measure traffic and improve the site (Google Analytics).",
      marketingTitle: "Marketing",
      marketingDesc: "Used to measure ad effectiveness and display relevant offers (Google Ads, Meta).",
    },
  },
  ru: {
    nav: { offer: "Предложение", why: "Почему мы", process: "Как это работает", faq: "Вопросы", contact: "Контакты" },
    phone: "+351 913 254 957",
    hero: {
      tag: "Отдых и экскурсии",
      title1: "Мадейра", title2: "по-новому",
      desc: "Отельные пакеты, экскурсии с русскоязычным гидом, спортивные сборы и корпоративные поездки. Организуем вашу мечту на Жемчужине Атлантики – с трансфером из аэропорта.",
      cta: "Получить индивидуальное предложение",
      cta2: "Смотреть предложение",
      reviews: "более 200 довольных путешественников",
    },
    usp: ["Трансфер из аэропорта", "Лицензия RNAVT 11932", "Поддержка на русском"],
    quiz: {
      step: "Шаг", of: "из", perk: "Трансфер из аэропорта!",
      q1Title: "Какая поездка вас интересует?",
      q1Sub: "Выберите ближайший вариант – мы уточним детали.",
      q2Title: "Когда планируете поездку?",
      q2Sub: "Предложим лучшие даты и цены.",
      q3Title: "Какой бюджет рассматриваете?",
      q3Sub: "У нас есть варианты в каждой ценовой категории.",
      q4Title: "Почти готово!",
      q4Sub: "Оставьте контакт – свяжемся в течение 48 часов с готовым предложением.",
      name: "Имя и фамилия", email: "E-mail", phone: "Телефон",
      consent: "Я согласен(на) на контакт по этому предложению и принимаю политику конфиденциальности.",
      back: "Назад", next: "Далее", submit: "Отправить запрос", sending: "Отправка...",
      successTitle: "Спасибо!",
      successDesc: "Ваш запрос отправлен. Наш менеджер на Мадейре свяжется с вами в течение 48 часов с индивидуальным предложением.",
      footer: "Ваши данные в безопасности. Без спама. RNAVT n° 11932.",
      errSelectTrip: "Выберите тип поездки", errSelectTime: "Выберите срок", errSelectBudget: "Выберите бюджет",
      errName: "Введите имя", errEmail: "Введите e-mail", errConsent: "Требуется согласие",
      sent: "Отправлено! Ответим в течение 48 ч.", failed: "Ошибка отправки. Попробуйте снова.",
      tripOptions: ["Отельный пакет / отдых", "Экскурсии с гидом", "Спортивный сбор", "Групповая / корпоративная поездка", "Аренда автомобиля"],
      timelineOptions: ["Как можно скорее", "В течение месяца", "В течение 3 месяцев", "Позже / по сезону", "Просто смотрю"],
      budgetOptions: ["До 1 500 € / чел.", "1 500 – 3 000 € / чел.", "3 000 – 5 000 € / чел.", "Свыше 5 000 € / чел."],
    },
    offer: {
      tag: "Наше предложение", title1: "Всё, что нужно", title2: "на райском острове",
      desc: "Полная организация поездок – от логистики и проживания до развлечений и трансферов. Каждое предложение индивидуальное.",
      cta: "Узнать подробнее",
      items: [
        { title: "Отельные пакеты и отдых", desc: "От уютных 3* до люксовых 5* с видом на Атлантику. Прямые контракты с отелями – лучшие цены.", price: "от 498 €" },
        { title: "Экскурсии с гидом", desc: "Левады, утёс Cabo Girão, Pico do Areeiro, Santana. Индивидуальные и групповые маршруты с гидом.", price: "от 50 €" },
        { title: "Спортивные сборы", desc: "Футбол, теннис, настольный теннис, падел, лёгкая атлетика, плавание. Профессиональные объекты и тренеры по всему острову.", price: "индивидуальный расчёт" },
        { title: "Корпоративные поездки", desc: "Incentive, тимбилдинг, корпоративные ивенты – приключения и отдых на райском острове.", price: "по запросу" },
        { title: "Аренда автомобилей", desc: "Седаны, внедорожники, 7-местные минивэны. Получение в аэропорту Funchal или у отеля. Полная страховка и поддержка 24/7.", price: "от 45 € / день" },
      ],
    },
    why: {
      tag: "Наши преимущества", title1: "Почему", title2: "Madeira.com.pl?",
      desc: "Многолетний опыт, лицензированная деятельность и личный подход – основа нашей работы.",
      items: [
        { title: "Лицензия RNAVT 11932", desc: "Работаем легально по португальской туристической лицензии – полная гарантия безопасности бронирования." },
        { title: "10+ лет опыта", desc: "Сотни организованных поездок, спортивных клубов и групп. Знаем Мадейру как свои пять пальцев." },
        { title: "Поддержка на русском", desc: "Персональный менеджер на каждом этапе – от планирования до гида и поддержки 24/7 на острове." },
      ],
    },
    process: {
      tag: "Как это работает", title1: "Три шага к", title2: "поездке мечты",
      cta: "Получить бесплатный расчёт",
      steps: [
        { title: "Заполните форму", desc: "Короткая анкета из 4 шагов – меньше 2 минут. Тип поездки, даты, бюджет." },
        { title: "Индивидуальное предложение", desc: "За 48 часов подготовим персональный план – отели, экскурсии, трансферы, развлечения." },
        { title: "Летите на Мадейру", desc: "Встретим в аэропорту (бесплатно!), позаботимся обо всём. Вы просто наслаждаетесь островом." },
      ],
    },
    stats: [
      { suffix: "+", label: "лет опыта" },
      { suffix: "+", label: "организованных поездок" },
      { suffix: "%", label: "индивидуальные предложения" },
      { suffix: "ч", label: "время ответа" },
    ],
    faq: {
      tag: "Частые вопросы", title1: "FAQ – нас часто", title2: "спрашивают",
      items: [
        { q: "Что входит в бесплатный трансфер?", a: "При каждом бронировании от 7 дней предоставляем бесплатный частный трансфер из аэропорта Funchal в отель и обратно." },
        { q: "Как долго готовится предложение?", a: "Индивидуальное предложение – в течение 48 часов. Групповые и корпоративные – до 72 часов." },
        { q: "Организуете ли поездки для спортклубов?", a: "Да. Специализируемся на футбольных, теннисных, легкоатлетических, плавательных и падел-сборах. Есть прямые контракты с объектами." },
        { q: "На каком языке проходят экскурсии?", a: "Все экскурсии проводим с гидом, проживающим на Мадейре – доступны польский и русский." },
        { q: "Можно ли платить в рассрочку?", a: "Да, предлагаем гибкие формы оплаты – аванс + рассрочка перед вылетом. Детали обсуждаем индивидуально." },
      ],
    },
    contact: {
      tag: "Контакты", title1: "Поговорим о вашей", title2: "поездке на Мадейру",
      desc: "Есть вопросы или хотите назначить разговор? Звоните или пишите – менеджер с Мадейры на связи.",
      call: "Позвонить", write: "Написать", office: "Офис",
      address: "Rua da Bolivia 72-JS, 9000-087 Funchal, Madeira",
      license: "Туристические лицензии RNAVT n° 11932 / RNAAT n° 229/2026",
      formTitle: "Отправить сообщение", message: "Сообщение", messagePlaceholder: "Опишите, какая поездка вас интересует...",
      submit: "Отправить сообщение", sending: "Отправка...",
      consent: "Принимаю политику конфиденциальности и согласен на контакт.",
      successTitle: "Спасибо!", successDesc: "Мы свяжемся с вами как можно скорее.",
      sent: "Сообщение отправлено!", failed: "Ошибка отправки. Попробуйте снова.",
      errRequired: "Заполните обязательные поля", errConsent: "Требуется согласие",
    },
    footer: { tag1: "Контакты", tag2: "Навигация", tag3: "Соцсети", desc: "Ваш эксперт по поездкам, экскурсиям и сборам на Мадейре.", rights: "Все права защищены." },
    cookies: {
      title: "Мы уважаем вашу конфиденциальность",
      desc: "Мы используем cookies для работы сайта, аналитики и ремаркетинга. Вы можете принять все, отклонить или настроить свои предпочтения.",
      accept: "Принять все",
      reject: "Отклонить",
      settings: "Настройки",
      save: "Сохранить выбор",
      essentialTitle: "Необходимые",
      essentialDesc: "Нужны для работы сайта – форма, сессия, безопасность. Всегда активны.",
      analyticsTitle: "Аналитические",
      analyticsDesc: "Помогают измерять трафик и улучшать сайт (Google Analytics).",
      marketingTitle: "Маркетинговые",
      marketingDesc: "Используются для измерения эффективности рекламы и показа релевантных предложений (Google Ads, Meta).",
    },
  },
};

const LanguageContext = createContext({ lang: "pl", setLang: () => {}, t: dict.pl });

export function LanguageProvider({ children }) {
  const [lang, setLangState] = useState(() => localStorage.getItem("madeira_lang") || "pl");
  useEffect(() => {
    localStorage.setItem("madeira_lang", lang);
    document.documentElement.lang = lang;
  }, [lang]);
  const setLang = (l) => setLangState(l);
  return (
    <LanguageContext.Provider value={{ lang, setLang, t: dict[lang] || dict.pl }}>
      {children}
    </LanguageContext.Provider>
  );
}

export const useLang = () => useContext(LanguageContext);
